import React from "react";
import { Table, Empty } from "antd";
import get from "lodash/get";

import TableSummary from "./TableSummary";
import getTimeSummaryColumns from "../../../constants/tableColumns/summaryReportsColumns/getInjectionMouldingTimeColumns";
import { getTransformedData } from "../../../utilities/timeSummary";

const TimeSummaryTable = ({ data, filter }) => {
  const { tableData, totals } = getTransformedData(data);

  const columns = getTimeSummaryColumns(tableData, filter);

  const hasData = tableData.some(
    (row) => get(row, "component") !== "NO_COMPONENTS",
  );

  return (
    <div className="mx-auto bg-white rounded-lg shadow-md">
      <Table
        columns={columns}
        dataSource={tableData}
        bordered
        pagination={false}
        rowKey={(record) => get(record, "id") || crypto.randomUUID()}
        size="small"
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="No data to display in this report"
            />
          ),
        }}
        className="mb-20 custom-horizontal-scrollbar"
        summary={() => (
          <TableSummary hasData={hasData} totals={totals} filter={filter} />
        )}
      />
    </div>
  );
};
export default TimeSummaryTable;
